import React from 'react';

/*
 MapEmbed is a thin wrapper for embedding maps.
 Replace the iframe src with MapMyIndia embed or use MapMyIndia Web SDK.
 Use REACT_APP_MAP_MY_INDIA_KEY env var when replacing.
*/
export default function MapEmbed({ lat = 13.010, lng = 80.190, zoom = 14 }) {
  const src = `https://maps.google.com/maps?q=${lat},${lng}&z=${zoom}&output=embed`;

  return (
    <iframe
      title="map"
      src={src}
      frameBorder="0"
      allowFullScreen
      loading="lazy"
      style={{ width: "100%", height: "100%" }} // ✅ let parent control height
    />
  );
}
